import { Button, Tooltip } from "antd";

export const IconButton = ({ icon, onClick, tooltip = null, disabled = false }) => {
  const button = (
    <Button
      type="link"
      style={{ height: "auto", lineHeight: 1, padding: 0 }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </Button>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};
